import CustomerActivityRenderer from "./CustomerActivityRenderer";
import CustomerActivityPopupRenderer from "./CustomerActivityPopupRenderer";

export default CustomerActivityRenderer;

export { CustomerActivityPopupRenderer };
